import { ModuleType } from 'global-services/constants/OhsObject';
import { OhsFilterList } from 'dashboard/topFilter/OhsFilterModels';
import { GlobalSearchState } from 'search/OhsSearchModels';
import { ApiResListsType } from 'global-services/api/OhsApiModels';

import OhsInspectionRecord from './models/OhsInspectionRecord';

export enum InspectionScheduledPreset {
  View1 = 'view_1',
  View2 = 'view_2',
}

export enum InspectionPreset {
  View1 = 'view_1',
  View2 = 'view_2',
  View3 = 'view_3',
}

export interface OhsInspectionCustomFilters {
  workplaceOwned?: boolean;
  allocatedToOrg?: boolean;
  allocatedToWorkplace?: boolean;
  notAllocated?: boolean;
  archived?: boolean;
  categories?: string[];
  workplaces?: string[];
  next?: string;
}

export interface OhsInspectionFilterPayload extends OhsInspectionCustomFilters {
  viewPreset?: 'view_1' | 'view_2' | 'view_3';
  page?: number;
  sort: {
    order: number;
    key: string;
  };
  count: boolean;
  dateDue?: { start: string; end: string };
}

export interface OhsAvailableInspectionFilterPayload extends OhsInspectionCustomFilters {
  page?: number;
  sort?: {
    order: number;
    key: string;
  };
  count: boolean;
}

export interface OhsInspectionScheduleFilterPayload extends OhsInspectionCustomFilters {
  viewPreset?: InspectionScheduledPreset;
  page?: number;
  sort: {
    order: number;
    key: string;
  };
  count: boolean;
}

export interface OhsInspectionMain {
  searchKey: string;
  substringSearch: boolean;
  highlight: boolean;
  filter: OhsInspectionFilterPayload;
  viewPreset: InspectionPreset;
  sort: {
    order: number;
    key?: string;
    relevance?: boolean;
  };
}

export interface OhsInspectionScheduledMain {
  searchKey: string;
  substringSearch: boolean;
  highlight: boolean;
  filter: OhsInspectionScheduleFilterPayload;
  viewPreset: InspectionScheduledPreset;
  sort: {
    order: number;
    key?: string;
    relevance?: boolean;
  };
}

export interface OhsAvailableInspectionMain {
  searchKey: string;
  substringSearch: boolean;
  highlight: boolean;
  filter: OhsAvailableInspectionFilterPayload;
  sort: {
    order: number;
    key?: string;
    relevance?: boolean;
  };
}

export interface OhsInspectionHistoryFilterPayload extends OhsInspectionCustomFilters {
  page?: number;
  sort: {
    order: number;
    key: string;
  };
  count: boolean;
  // TODO inspection history - add this
  // dateCompleted
  dateCompleted?: {
    start: string;
    end: string;
  };
}

export interface OhsModuleListsTypes {
  rowData: any[];
  isLoading: boolean;
  totalPages: number;
}

export interface InspectionAllocListRes {
  items: AllocatedListType[];
}
export interface AllocatedListType extends OhsInspectionRecord {
  _id: string;
  type: ModuleType;
  allocated: boolean;
  latestCompletedTask: string | null;
}

export interface OhsInspectionStart {
  _id: string;
  task: {
    _id: string;
  };
  tz: string;
  dateCommenced: string;
}

export interface OhsInspectionOneOffChild {
  _id: string;
  dateDue: string;
  notes: string;
  tzDateCreated: string;
}

export enum OhsInspectionViewPresets {
  View1InspectionList = 'view1InspectionList',
  View2InspectionList = 'view2InspectionList',
  View3InspectionList = 'view3InspectionList',
  view1InspectionScheduledList = 'view1InspectionScheduledList',
  view2InspectionScheduledList = 'view2InspectionScheduledList',
  view1InspectionHistoryList = 'view1InspectionHistoryList',
}

export interface InspectionListRecordState {
  isLoading: boolean;
  inspectionLists: ApiResListsType<any[]> | null;
  inspectionScheduledLists: ApiResListsType<any[]> | null;
  allocatedList: AllocatedListType[] | null;
  availableInspectionList: ApiResListsType<any[]> | null;
  availableInspectionSearch: GlobalSearchState;
  inspectionCopyList: {
    isLoading: boolean;
    copyList: OhsInspectionRecord[];
  };
  currentPage: number;
  currentViewPreset: OhsInspectionViewPresets;
}

export interface OhsInspectionRootState {
  globalfilter: {
    filterInfo: OhsFilterList;
  };
  inspection: InspectionListRecordState;
  globalSearch: GlobalSearchState;
}

export interface OhsAvailableInspectionTask {
  dateDue: string;
  for: { _id: string };
  inExecution: boolean;
  reference: string;
  _id: string;
}
